import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, useLocation } from 'react-router';
import { LongLoader } from '../../components/LongLoader';
import { isUserVerified } from '../../helpers/auth';
import { auth } from '../../firebase';
import { openAlert } from '../../slices/alert';
import { storeSelectedRm } from '../../slices/selected';
import { getRm } from '../../api/company';
import { addFollow } from '../../api/follow';
import moment from "moment";
import { useTranslation } from 'react-i18next';
import { selectName, selectUser } from '../../slices/profile';
import { studentFollowingRmIdArray } from '../../helpers/student';
import { analyticsEvents, ROUTES } from '../../db/models/const';

export const StudentSpecial = () => {
    const [rm, setRm] = useState();
    const user = useSelector(selectUser);
    const displayName = useSelector(selectName);
    const [followLoading, setFollowLoading] = useState(false);
    const [action, setAction] = useState();
    const dispatch = useDispatch();
    const history = useHistory();
    const location = useLocation();
    const { t } = useTranslation();

    useEffect(() => {

    }, [])

    useEffect(() => {
        const query = new URLSearchParams(location.search);
        const action = query.get("action");
        setAction(action);

        switch (action) {
            case "follow":
                const rmId = query.get("rmId");

                // do nothing if user is not verified and passed 5 days since signup
                const signed = moment(auth.currentUser.metadata.creationTime);
                const now = moment();
                const diff = moment.duration(now.diff(signed));
                const days = diff.asDays();
                if (!isUserVerified() && days > 5) {
                    dispatch(openAlert({ type: "warning", message: t("alert_verify_account") }));
                    history.push(ROUTES.PROFILE);
                    return;
                }

                // get full rm info from rmId 
                if (!rmId) return;
                setFollowLoading(true);
                getRm(rmId).then(rm => setRm(rm));

                break;

            default:
                history.push(ROUTES.ME);
        }
    }, [])

    useEffect(() => {
        if (!rm || !user || !displayName) return;

        // if user already follows rm go to rm page
        const followIds = studentFollowingRmIdArray(user);
        if (followIds.includes(rm.id)) {
            dispatch(openAlert({ type: "warning", message: t("alert_rm_already_followed") }));
            // dispatch(storeSelectedRm({ rm }));
            history.push(ROUTES.FOLLOW.replace(":rmId", rm.id));
            return;
        }

        addFollow(rm.id)
            .then(() => {

                dispatch(storeSelectedRm({ rm }));
                dispatch(openAlert({ type: "success", message: t("alert_rm_followed") }));
                history.push(ROUTES.PROFILE);
            })
            .catch(error => {
                dispatch(openAlert({ type: "error", message: t("alert_generic_error") }));
                history.push(ROUTES.ME);
            })
    }, [rm, user, displayName])

    return (
        <div className="studentSpecial">
            {action === "follow" && followLoading && <LongLoader />}
        </div>
    )
}
